export { default as Medias } from './Medias';
